module.exports = __webpack_public_path__ + "static/media/indicator-green-15-25.2d1dd404.png";